import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgLaborBay } from "@/lib/manufacturing/laborBillingTypes";
import {
  laborRateCatalogQueryIsDefault,
  type LaborRateActiveFilter,
  type LaborRateBayFilter,
  type LaborRateCatalogQuery,
  type LaborRateRoofFilter,
} from "@/lib/manufacturing/filterLaborRateCatalog";

const filterSelectClass = `${inputClass} min-w-0 px-2 py-1.5 text-xs`;

export function LaborRateCatalogToolbar({
  query,
  bays,
  onChange,
  onClear,
}: {
  query: LaborRateCatalogQuery;
  bays: MfgLaborBay[];
  onChange: (next: LaborRateCatalogQuery) => void;
  onClear: () => void;
}) {
  const searchTrim = query.search.trim();
  const filtered = !laborRateCatalogQueryIsDefault(query);

  return (
    <div className="mb-3 space-y-2">
      <div className="relative min-w-0">
        <input
          className={`${inputClass} pr-8`}
          value={query.search}
          onChange={(e) => onChange({ ...query, search: e.target.value })}
          placeholder="Search code, label, option, notes, bay — commas AND…"
          aria-label="Search rate catalog"
          autoComplete="off"
        />
        {searchTrim ? (
          <button
            type="button"
            className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded px-1.5 py-0.5 text-sm leading-none text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-100"
            onClick={() => onChange({ ...query, search: "" })}
            aria-label="Clear search"
          >
            ×
          </button>
        ) : null}
      </div>
      <div className="grid gap-1.5 sm:grid-cols-3">
        <select
          className={filterSelectClass}
          value={query.activeFilter}
          onChange={(e) =>
            onChange({ ...query, activeFilter: e.target.value as LaborRateActiveFilter })
          }
          aria-label="Status filter"
        >
          <option value="all">All statuses</option>
          <option value="active">Active only</option>
          <option value="inactive">Inactive only</option>
        </select>
        <select
          className={filterSelectClass}
          value={query.roofFilter}
          onChange={(e) =>
            onChange({ ...query, roofFilter: e.target.value as LaborRateRoofFilter })
          }
          aria-label="Roof eligibility filter"
        >
          <option value="all">Roof eligibility</option>
          <option value="roof">Roof eligible</option>
          <option value="not_roof">Not roof eligible</option>
        </select>
        <select
          className={filterSelectClass}
          value={query.bayFilter}
          onChange={(e) => onChange({ ...query, bayFilter: e.target.value as LaborRateBayFilter })}
          aria-label="Bay filter"
        >
          <option value="all">All bays</option>
          <option value="unlinked">No earning bay</option>
          {bays.map((bay) => (
            <option key={bay.id} value={bay.id}>
              {bay.name}
              {bay.is_active ? "" : " (inactive)"}
            </option>
          ))}
        </select>
      </div>
      {filtered ? (
        <button
          type="button"
          className="text-xs font-medium text-indigo-700 hover:underline dark:text-indigo-300"
          onClick={onClear}
        >
          Clear filters
        </button>
      ) : null}
    </div>
  );
}
